import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Document } from '../models/index';
import { Observable } from 'rxjs';

@Injectable()
export class DocumentService {
  url: string;
  constructor(private httpClient: HttpClient, @Inject('API_URL') apiUrl: string) {
    this.url = apiUrl + 'document/';
  }

  getById = (id: string): Observable<Document> => this.httpClient.get<Document>(`${this.url}${id}`);
}
